const BOOTSTRAP_LOADER_ID = "app-bootstrap-loader";
const BOOTSTRAP_LOADER_STYLE_ID = "app-bootstrap-loader-style";
const BOOTSTRAP_LOADER_REMOVE_DELAY_MS = 200;

let hideScheduled = false;

export function preserveBootstrapLoader(rootElement: HTMLElement | null) {
  if (typeof window === "undefined" || !rootElement) return;
  if (document.getElementById(BOOTSTRAP_LOADER_ID)) return;

  const loader = rootElement.firstElementChild;
  if (!(loader instanceof HTMLDivElement)) return;

  const inlineStyle = Array.from(rootElement.children).find(
    (node): node is HTMLStyleElement => node instanceof HTMLStyleElement && node.textContent?.includes("serafisioLoaderSpin") === true,
  );

  loader.id = BOOTSTRAP_LOADER_ID;
  loader.dataset.state = "visible";
  loader.style.opacity = "1";
  loader.style.visibility = "visible";
  loader.style.pointerEvents = "auto";
  loader.style.transition = "opacity 200ms ease, visibility 200ms ease";
  loader.style.willChange = "opacity";

  document.body.appendChild(loader);

  if (inlineStyle) {
    inlineStyle.id = BOOTSTRAP_LOADER_STYLE_ID;
    document.head.appendChild(inlineStyle);
  }
}

export function hideBootstrapLoader() {
  if (hideScheduled || typeof window === "undefined") return;

  const loader = document.getElementById(BOOTSTRAP_LOADER_ID);
  if (!loader) {
    hideScheduled = true;
    return;
  }

  if (loader.dataset.state === "hidden" || loader.dataset.state === "hiding") return;

  hideScheduled = true;
  loader.dataset.state = "hiding";

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      loader.style.opacity = "0";
      loader.style.visibility = "hidden";
      loader.style.pointerEvents = "none";
      loader.dataset.state = "hidden";
      window.setTimeout(() => {
        loader.remove();
        document.getElementById(BOOTSTRAP_LOADER_STYLE_ID)?.remove();
      }, BOOTSTRAP_LOADER_REMOVE_DELAY_MS);
    });
  });
}
